export * from './notificacoes-query.interface';
